<template>
   
  <div>
       
    <!-- 个人登录主页 -->
       
    <div class="wrapper">
           
      <v-head :collapse="collapse" @collapseChage="collapseChage">
               
        <p>高中课程学习与专业选择互适应系统</p>
             
      </v-head>
           
      <!-- <v-sidebar :items="menu"></v-sidebar> -->
           
      <div class="sidebar">
               
        <el-menu
          class="sidebar-el-menu"
          :collapse="collapse"
          background-color="#0d2c4f"
          text-color="#bfcbd9"
          unique-opened
          router
        >
                   
          <template v-for="item in items">
                       
            <template>
                           
              <el-menu-item :index="item.index" :key="item.index">
                                <i :class="item.icon"></i>                
                <span slot="title">{{ item.title }}</span>              
              </el-menu-item>
                         
            </template>
                     
          </template>
                 
        </el-menu>
             
      </div>
           
      <div class="content-box" :class="{ 'content-collapse': collapse }">
               
        <div class="content">
                   
          <transition name="move" mode="out-in">
                        <router-view></router-view>          
          </transition>
                 
        </div>
             
      </div>
         
    </div>
     
  </div>
</template>

<script>
import vHead from "../../components/common/Header.vue";
// import vSidebar from '../../components/common/Sidebar.vue';
export default {
  data() {
    return {
      collapse: false,
      items: [
        {
          icon: "el-icon-menu",
          index: "/adaptation/subsystem",
          title: "专业管理",
        },
        {
          icon: "el-icon-s-custom",
          index: "/adaptation/personality",
          title: "用户管理",
        },
        {
          icon: "el-icon-set-up",
          index: "/adaptation/role",
          title: "角色管理",
        }
        // {
        //   icon: "el-icon-s-custom",
        //   title: "个人资料",
        //   subs: [
        //     {
        //       index: "PersonalDate",
        //       title: "编辑我的资料",
        //     },
        //   ],
        // },
      ],
    };
  },
  components: {
    vHead,
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  methods: {
    collapseChage(msg) {
      this.collapse = msg;
    },
  },
  created() {

  },
};
</script>
<style lang="less">
.wrapper {
  .sidebar {
    .el-menu {
      height: 100vh;
    }
  }
  
}
</style>

<style scoped>
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}

.sidebar-el-menu li {
  font-size: 17px;
}

.sidebar-el-menu span {
  font-size: 17px;
}

.sidebar .el-menu-item {
  height: 64px;
  line-height: 64px;
}

.sidebar .el-menu-item.is-active {
  background-color: #0678cf !important;
}
